export default function TabNavigation({ tabs, activeTab, onTabChange }) {
    return (
        <div className="bg-gradient-to-r from-white to-slate-50/50 border-b border-slate-200/60 flex-shrink-0">
            <nav className="flex px-8 gap-2">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`
              flex items-center gap-3 py-4 px-6 font-medium text-sm transition-all duration-200 rounded-t-2xl border-b-3
              ${activeTab === tab.id
                                ? 'bg-white border-orange-500 text-orange-600 shadow-sm -mb-px'
                                : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-white/60'
                            }
            `}
                    >
                        <div className={`p-1.5 rounded-lg ${activeTab === tab.id
                            ? 'bg-orange-50 text-orange-600'
                            : 'bg-slate-100 text-slate-500'
                            }`}>
                            {tab.icon}
                        </div>
                        {tab.label}
                    </button>
                ))}
            </nav>
        </div>
    );
}
